import React, { Component } from "react";
import "./specialColumnList.css";
import {
  Button,
  Input,
  TreeSelect,
  Modal,
  Switch,
  Icon,
  Upload,
} from "antd";
const typeListItem = [
  {
    title: "请选择",
    value: "0",
    key: "0",
  },
  {
    title: "启用",
    value: "1",
    key: "1",
  },
  {
    title: "禁用",
    value: "2",
    key: "2",
  },
];
class ViewSpecialColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storagePicture: "",
      visible: false,
      showPicture: null,
      name: this.props.name,
      shortName: this.props.shortName,
      enabled: this.props.enabled, //授权
      top: this.props.top, //置顶
      titlePic: "",
    };
  }
  // 编辑
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  onChange = () => {
    let top = this.state.top;
    this.setState({
      top: !top,
    });
  };
  // 取消封面图
  cancel = () => {
    this.setState({
      titlePic: "",
    });
  };
  render() {
    // 上传
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? "loading" : "plus"} />
        <div style={{ color: "purple" }}>点击上传</div>
      </div>
    );
    const { titlePic } = this.state;
    return (
      <div>
        <Modal
          title="新增专题"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width="800px"
          bodyStyle={{ height: "500px" }}
          footer={null}
        >
          <div>
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: "10px" }}>专栏封面</div>
              <div
                style={{ marginLeft: "50px", width: "102px", height: "102px" }}
              >
                <div className="atlasListPic">
                  <Upload
                    name="file"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    action="/cm-sites-pms/ueditor/control?action=uploadimage"
                    onChange={this.UploadImg}
                  >
                    {titlePic === "" ? (
                      uploadButton
                    ) : (
                      <img
                        style={{ width: "102px", height: "102px" }}
                        src={titlePic}
                        alt=""
                      />
                    )}
                  </Upload>
                </div>

                <div
                  style={{
                    width: "100px",
                    color: "red",
                    marginLeft: "5px",
                    marginTop: "20px",
                    cursor: "pointer",
                  }}
                  onClick={this.cancel}
                >
                  【取消封面图】
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: "50px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>专栏全称</div>
              <div style={{ marginLeft: "50px", width: "600px" }}>
                <Input
                  placeholder="请输入专栏全称(不超过40个字符)"
                  value={this.state.name}
                  onChange={(e) => this.nameOnChange(e)}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>专栏简称</div>
              <div style={{ marginLeft: "50px", width: "600px" }}>
                <Input
                  placeholder="请输入专栏简称(不超过10个字符)"
                  value={this.state.shortName}
                  onChange={(e) => this.shortNameOnChange(e)}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>状态</div>
              <div style={{ marginLeft: "78px" }}>
                <TreeSelect
                  style={{ width: "200px" }}
                  value={this.state.enabled}
                  treeData={typeListItem}
                  onChange={(value) => {
                    this.state.enabled = value;
                    this.setState({});
                  }}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>置顶</div>
              <div style={{ marginLeft: "78px" }}>
                <Switch onChange={this.onChange} checked={this.state.top} />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "50px",
              }}
            >
              <div>
                <Button type="primary" onClick={this.store}>
                  保存
                </Button>
              </div>
              <div style={{ marginLeft: "20px" }}>
                <Button type="primary" onClick={this.handleCancel}>
                  取消
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
  // 上传
  UploadImg = (info) => {
    if (info.file.status === "done") {
      this.setState({
        titlePic: info.file.response.url,
      });
    }
  };
  // 点击保存
  store = () => {
    let obj = {
      updateDate: this.props.updateDate,
      createDate: this.props.createDate,
      showPicture: this.state.showPicture,
      storagePicture: this.state.storagePicture,
      name: this.state.name,
      shortName: this.state.shortName,
      enabled: this.state.enabled === "1",
      top: this.state.top,
      id: this.props.id,
    };
    this.props.getEditStore(obj);
    this.setState({
      visible: false,
    });
  };
  nameOnChange = (e) => {
    this.setState({
      name: e.target.value,
    });
  };
  shortNameOnChange = (e) => {
    this.setState({
      shortName: e.target.value,
    });
  };
}


export default ViewSpecialColumn;
